import React, { useState } from "react";
import { EditableField } from "../../components/editable-field";
import { Button } from "../../components/button";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { useToast } from "../../components/toast";
import { HelpDeskTicketsAPI } from "../../APIs/help_desk_tickets.api";
import { useHelpDeskTickets } from "../../context/HelpDeskTicketsContext";

interface HelpDeskTicketFormProps {
  hasPendingTicket: boolean;
}

export const HelpDeskTicketForm: React.FC<HelpDeskTicketFormProps> = ({
  hasPendingTicket,
}) => {
  const [formData, setFormData] = useState<{
    title: string;
    description: string;
  }>({
    title: "",
    description: "",
  });
  const { addToast } = useToast();
  const { getUserHDTickets } = useHelpDeskTickets();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await HelpDeskTicketsAPI.createHelpDeskTicket(formData);
      if (response.statusCode === 201) {
        setFormData({
          title: "",
          description: "",
        });
        getUserHDTickets();

        addToast({
          message: "Solicitud enviada",
          type: "success",
          location: "bottom-center",
        });
      } else {
        addToast({
          message: response.message,
          type: "error",
          location: "bottom-center",
        });
      }
    } catch (error) {
      addToast({
        message: "Error al enviar solicitud, intente nuevamente",
        type: "error",
        location: "bottom-center",
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLElement>) => {
    const { name, value } = e.target as HTMLInputElement;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Necesitas Ayuda?
      </h2>
      {hasPendingTicket ? (
        <div className="bg-amber-50 border border-amber-200 text-amber-700 p-4 rounded-md mb-4">
          <p>
            Ya tenés una solicitud abierta. Por favor, esperá una respuesta o
            revisá tu solicitud existente →
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <EditableField
            label="Título"
            value={formData.title}
            onChange={handleChange}
            required
            type="text"
            name="title"
            minLength={3}
            maxLength={100}
            placeholder="Contanos brevemente tu problema o consulta"
          />

          <EditableField
            label="Descripción"
            value={formData.description}
            onChange={handleChange}
            type="textarea"
            name="description"
            minLength={3}
            maxLength={1000}
            placeholder="Describí tu problema o consulta con más detalles"
          />

          <Button
            type="submit"
            text="Enviar"
            variant="create"
            icon={<ArrowRightIcon className="w-5 h-5 mr-2" />}
          />
        </form>
      )}
    </div>
  );
};
